<template>
  <span>
    <v-switch
      v-if="switchElement"
      v-model="checkbox"
      hideDetails
      :disabled="disabled"
      :label="label"
      class="bm-checkbox"
      :class="{ reverse }"
    />
    <v-checkbox
      v-else
      v-model="checkbox"
      :disabled="disabled"
      :label="label"
      class="bm-checkbox"
      :class="{ reverse }"
    />
  </span>
</template>
<script setup lang="ts">
import { watch, onMounted } from 'vue';
import { useStorage } from '@vueuse/core';
import type { BMCheckBoxProps } from './BMCheckBox.types';

const props = withDefaults(defineProps<BMCheckBoxProps>(), {
  disabled: false
});

const checkbox = defineModel<boolean>({ default: false });

const storageRef = props.localStorageKey
  ? useStorage(props.localStorageKey, checkbox.value)
  : null;

onMounted(() => {
  if (storageRef !== null) {
    checkbox.value = Boolean(storageRef.value);
  }
});

if (storageRef) {
  watch(checkbox, (newVal) => {
    storageRef.value = newVal;
  });

  watch(storageRef, (newVal) => {
    if (newVal !== checkbox.value) {
      checkbox.value = newVal;
    }
  });
}
</script>
<style scoped>
.reverse :deep(.v-input__slot) {
  flex-direction: row-reverse;
}
.bm-checkbox :deep(.v-input__slot) {
  /* justify-content: center; */
  top: 9px;
}
.bm-checkbox :deep(.v-input__slot label) {
  flex: 0.2 1 auto !important;
}
.bm-checkbox {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
</style>
